import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { IoToday } from "react-icons/io5";
import { BsFillAwardFill } from "react-icons/bs";
import { MdTaskAlt } from "react-icons/md";
import { BiCategoryAlt } from "react-icons/bi";
import { FaPhone } from "react-icons/fa6";

const MobileBar = () => {
  const [toggle, setToggle] = useState(false);
  const handleToggle = () => setToggle(!toggle);
  const [activeTab, setActiveTab] = useState("home");
  const location = useLocation();
  const pathname = location.pathname;
  const [modal, setModal] = useState(false);

  useEffect(() => {
    if (pathname === "/app") {
      setActiveTab("app");
    } else if (pathname === "/products") {
      setActiveTab("products");
    } else if (pathname === "/about-us") {
      setActiveTab("about-us");
    } else if (pathname === "/contact") {
      setActiveTab("contact");
    }
  }, [pathname]);
  return (
    <Container>
      <Link to={"/app"} className="link-styles">
        <IoToday className="icon" />
      </Link>
      <Link to={"/products"} className="link-styles">
        <BsFillAwardFill className="icon" />
      </Link>
      <Link to={"/about-us"} className="link-styles">
        <MdTaskAlt className="icon" />
      </Link>
      <Link to={"/categories"} className="link-styles">
        <BiCategoryAlt className="icon" />
      </Link>
      <Link to={"/contact"} className="link-styles">
        <FaPhone className="icon phone" />
      </Link>
    </Container>
  );
};
const Container = styled.div`
  background: #333d55ba;
  transition: 0.4s;
  backdrop-filter: blur(7px);
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1% 10%;
  width: 100%;
  height: 65px;
  z-index: 201;
  box-sizing: border-box;
  border-radius: 20px 20px 0 0;
  .closedModal {
    right: -200vw;
    position: fixed;
    transition: 0.4s;
  }
  .icon {
    font-size: 28px;
    color: #ffffff;
  }
  .phone {
    font-size: 24px;
  }

  button {
    background: white;
    border: none;
    margin: auto;
    display: flex;
    color: #202020;
    padding: 7px 14px;
    font-size: 18px;
    border-radius: 20px;
    font-family: "Poppins", cursive;
    cursor: pointer;
    transition: 0.4s;
    :hover {
      box-shadow: 0 0 14px 2px var(--shadowColor);
    }
  }
  @media (max-width: 400px) {
    .modal {
      width: 97%;
    }
  }
`;

export default MobileBar;
